import colorsVars from 'styles/colors.module.scss';
import { customScroll } from 'styles/variables';

const {
    myCustomSelectBorderColor,
    myCustomSelectBg,
    myCustomSelectedMultiBg,
    myCustomSelectTextColor,
    disabledInput,
    errorRedColor,
} = colorsVars;

export const SelectStyles = {
    menu: (styles) => ({
        ...styles,
        minWidth: '150px',
        width: 'max-content',
        backgroundColor: 'var(--select_menu_background)',
        borderRadius: '16px',
        color: 'var(--select_menu_color)',
        border: 'solid 1px var(--select_menu_border)',
        overflow: 'hidden',
        zIndex: 10,
    }),
    control: (styles, { isDisabled, selectProps }) => ({
        ...styles,
        minWidth: '150px',
        minHeight: '38px',
        borderRadius: '8px',
        border: `1px solid ${selectProps?.isError ? errorRedColor : myCustomSelectBorderColor}`,
        backgroundColor: isDisabled ? disabledInput : myCustomSelectBg,
        color: myCustomSelectTextColor,
        boxShadow: 'none',
        '&:hover': {
            border: `1px solid ${myCustomSelectBorderColor}`,
        },
    }),
    valueContainer: (styles) => ({ ...styles, padding: '2px  8px' }),

    input: (styles) => ({
        ...styles,
        color: myCustomSelectTextColor,
        margin: '2px',
        paddingBottom: '2px',
        paddingTop: '2px',
    }),
    indicatorSeparator: (styles) => ({ ...styles, marginTop: '8px', marginBottom: '8px' }),
    dropdownIndicator: (styles) => ({ ...styles, padding: '8px' }),
    clearIndicator: (styles) => ({ ...styles, padding: '8px' }),
    placeholder: (styles) => ({ ...styles, color: '#9299aa', margin: '0 0.20px' }),
    singleValue: (styles) => ({ ...styles, color: myCustomSelectTextColor, lineHeight: '20px' }),
    multiValue: (styles) => ({ ...styles, backgroundColor: myCustomSelectedMultiBg }),
    multiValueLabel: (styles) => ({
        ...styles,
        backgroundColor: myCustomSelectedMultiBg,
        color: myCustomSelectTextColor,
    }),
    multiValueRemove: (styles, { data, isDisabled }) => {
        return data.isFixed || isDisabled ? { ...styles, display: 'none' } : styles;
    },
    option: (styles, { data, isSelected }) => {
        return {
            ...styles,
            color: isSelected ? 'var(--text-primary)' : null,
            ':active': {
                backgroundColor: 'none',
            },
            ':hover': {
                cursor: 'pointer',
                backgroundColor: 'var(--button-secondary-bg_hover)',
            },
            '&:nth-of-type(2)': (data.value === 'default_value' || data.value === 'Unassigned') && {
                borderBottom: '1px dotted var(--text_color)',
                paddingBottom: '10px',
                paddingTop: '10px',
                marginBottom: '5px',
            },
        };
    },
    menuList: (styles) => ({
        ...styles,
        ...customScroll,
    }),
};

export const listStyleWithExclude = {
    ...SelectStyles,
    ...{
        multiValueLabel: (styles, { data }) => {
            return {
                ...styles,
                backgroundColor: data.value.isExclude ? '#FFE5E5' : myCustomSelectedMultiBg,
                color: data.value.isExclude ? '#000000' : myCustomSelectTextColor,
            };
        },
    },
};
